var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-alert",
    {
      attrs: {
        show: _vm.visible && _vm.alertShowDuration,
        dismissible: "",
        fade: "",
        variant: _vm.variant,
      },
      on: {
        dismissed: function () {
          return _vm.updateAlertShowDuration(0)
        },
        "dismiss-count-down": _vm.updateAlertShowDuration,
      },
    },
    [_vm._t("content")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }